// Generated by purs version 0.14.3
"use strict";
var $foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/partial/v3.0.0/src/Partial.js");
var crashWith = function (dictPartial) {
    return $foreign["_crashWith"];
};
var crash = function (dictPartial) {
    return crashWith()("Partial.crash: partial function");
};
module.exports = {
    crash: crash,
    crashWith: crashWith
};
